/**
 * Application-specific API endpoints configuration
 * This file wraps the package endpoints and provides application-specific constants
 */

import { createCarboWasteEndpoints, CARBOWASTE_WEBPAGE_URL } from '@carbowaste/api-client';
import { config } from '../config/environment';

// Create endpoints with app configuration
const carboWasteEndpoints = createCarboWasteEndpoints(config.api.baseUrl);

// Export with camelCase naming for backward compatibility
export const CarboWasteEndpoints_HealthCheck = carboWasteEndpoints.HealthCheck;
export const CarboWasteEndpoints_Subscription = carboWasteEndpoints.Subscription;
export const CarboWasteEndpoints_Registration = carboWasteEndpoints.Registration;
export const CarboWasteEndpoints_Unregistration = carboWasteEndpoints.Unregistration;
export const CarboWasteEndpoints_AddCompany = carboWasteEndpoints.AddCompany;
export const CarboWasteEndpoints_UpdateCompany = carboWasteEndpoints.UpdateCompany;
export const CarboWasteEndpoints_DeleteCompany = carboWasteEndpoints.DeleteCompany;
export const CarboWasteEndpoints_FindCompany = carboWasteEndpoints.FindCompany;
export const CarboWasteEndpoints_SendMessage = carboWasteEndpoints.SendMessage;
export const CarboWasteEndpoints_StartSheet = carboWasteEndpoints.StartSheet;
export const CarboWasteEndpoints_WasteCodeList = carboWasteEndpoints.WasteCodeList;
export const CarboWasteEndpoints_WasteProcessList = carboWasteEndpoints.WasteProcessList;

// Web page URL
export const CarboWasteEndPoints_WebPageUrl = CARBOWASTE_WEBPAGE_URL;

// Time delay for API calls (ms)
export const TimeDelayInMs = 500;
